import {withHandlers, withProps} from 'recompose'

import compose from 'lodash/flowRight'
import type {ComponentType} from 'react'
import {memo} from 'react'

import type {LocationProps} from '../../../../../../../routes'
import {getHrefWithQueryParams, withLocation} from '../../../../../../../routes'
import {queryToObject} from '../../../../../../../utils/queryParams'

import TableHeader from './TableHeader'
import type {OwnProps} from './TableHeader.types'

const TableHeaderContainer: ComponentType<OwnProps> = compose(
  memo,
  withLocation,
  withProps(({location}: OwnProps & LocationProps) => {
    const {order, orderBy} = queryToObject(location?.search)
    return {
      orderBy: orderBy ?? 'newFailure',
      order: order ?? 'desc',
    }
  }),
  withHandlers({
    onChangeQueryParams:
      ({location, navigate}: LocationProps) =>
      (newParams: Record<string, string | null | undefined>) =>
        navigate(
          getHrefWithQueryParams(location, null, oldParams => ({...oldParams, ...newParams})),
        ),
  }),
)(TableHeader)
export default TableHeaderContainer
